<template>
	<div fields question :id="`question-${questionData.number}`" @keyup.enter="submitQuestion">
		<questionheader :questionData="questionData" />
		<div data-question-main>
			<div v-for="(answer, index) in questionData.answers" :key="`answer-${index}`" data-answer :id="`question-${questionData.number}_answer-${index}`">
				<div data-answer-container :data-labels-next-to-answers="questionData.labelsNextToControl">
					<questioninput
						@element-focused="inputFocus($event, answer)"
						:answerData="answer"
						:questionData="questionData"
						:disabled="!get.editingAllowed(questionData) || questionData.type === `Commerce`"
					/>
					<answerdescription v-if="answer.description !== ``" :answerData="answer" :questionData="questionData" />
				</div>
			</div>
		</div>
		<questionfooter :questionData="questionData" />
		<validationpopup :questionValidation="questionValidation" />
	</div>
</template>

<script>
import mixins from "@/global/mixins";

export default {
	name: `fields-question`,
	mixins: [mixins.defaultQuestion],
	computed: {
		answersGiven() {
			return this.questionData.answers.filter((answer) => answer.openField !== ``).length;
		},
	},
	methods: {
		inputFocus: function (e, answer) {
			// This is for the feature 'Standaard antwoorden'. Only those fields have to be emptied when the user selects them
			if (answer.isEdited === undefined && answer.isDefaultAnswer) {
				answer.openField = "";
				answer.isEdited = true;
			}
		},
	},
};
</script>

<style scoped>
[data-answer] {
	align-items: flex-start;
	flex-direction: column;
}

[data-answer-container] {
	display: flex;
	align-items: center;
	width: 100%;
}
</style>